module.exports = __webpack_public_path__ + "static/peter-cookies@2x-d0d917b8291cc018ce0ff3129d666626.png";